import React from 'react';
import { Chip } from '@mui/material';
import { STATUS_COLOR } from '../format';
import type { PaymentStatus } from '../types';

export const PaymentStatusChip: React.FC<{ status: PaymentStatus }> = ({ status }) => (
  <Chip
    size="small"
    label={status.replace('_', ' ')}
    color={STATUS_COLOR[status]}
    variant={STATUS_COLOR[status] === 'default' ? 'outlined' : 'filled'}
  />
);
